<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Dealer Selection -->

      <div class="row align-items-center">
        <div class="col-md-4 mx-auto">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Bayii Seçimi</h4>
            </div>
            <div class="card-body">
              <select v-model="selectedDealer" class="form-control" @change="onDealerChange">
                <option value="all">Tümü</option>
                <option v-for="dealer in dealers" :key="dealer._id" :value="dealer._id">
                  {{ dealer.title }} ({{ dealer.code }})
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-4 mx-auto">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Grup Seçimi</h4>
            </div>
            <div class="card-body">
              <select v-model="selectedGroup" class="form-control" @change="onGroupChange">
                <option value="all">Tümü</option>
                <option v-for="group in groups" :key="group._id" :value="group._id">
                  {{ group.title }} ({{ group.code }})
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-md-4 mx-auto">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Hafta Seçimi</h4>
            </div>
            <div class="card-body">
              <select v-model="selectedWeek" class="form-control" @change="onWeekChange">
                <option v-for="week in weeks" :key="week.value" :value="week.value">
                  {{ week.title }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Basic Statics Card-->
      <div class="row">
        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-chart text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">Toplam Müşteri Sayısı</p>
              <h4 class="card-title">{{ cardStats.totalCustomers }}</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-tap-01 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Aktif Oynayan Oyuncu Sayısı</p>
              <h4 class="card-title">{{ cardStats.totalActiveCustomers }}</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-vector text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Toplam Bayii Sayısı</p>
              <h4 class="card-title">{{ cardStats.totalDealers }}</h4>
            </div>
          </stats-card>
        </div>
      </div>

      <!-- New Customers Statics Card-->
      <div class="row">
        <div class="col-xl-6 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-chart text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">Yeni Müşteri Sayısı</p>
              <h4 class="card-title">{{ cardStats.newCustomers }}</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-6 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-money-coins text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Yeni Müşterinin Çevirimi</p>
              <h4 class="card-title">{{ numeral(cardStats.newCustomersConversion).format('0,0.00') + ' TL' }}</h4>
            </div>
          </stats-card>
        </div>
      </div>

      <!-- Weekly Stats -->
      <div v-if="weeklyStatsLoading === true">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title text-center">Yükleniyor...</h4>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div v-if="weeklyStatsLoading === false && selectedWeek && selectedDealer" class="row">

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-money-coins text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Haftalık Yatırılan Para</p>
              <h4 class="card-title">{{ numeral(weekBySummary.totalDeposit).format('0,0.00') + ' TL' }}</h4>
            </div>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-money-coins text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Haftalık Çevirim</p>
              <h4 class="card-title">{{ numeral(weekBySummary.totalConversion).format('0,0.00') + ' TL' }}</h4>
            </div>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-money-coins text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Haftalık Toplam İade</p>
              <h4 class="card-title">{{ numeral(weekBySummary.totalConversionRefundedAmount).format('0,0.00') + ' TL' }}</h4>
            </div>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-money-coins text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Haftalık Net Çevirim</p>
              <h4 class="card-title">{{ numeral(weekBySummary.totalConversion - weekBySummary.totalConversionRefundedAmount).format('0,0.00') + ' TL' }}</h4>
            </div>
          </stats-card>
        </div>


      </div>


      <!-- Weekly Chart-->
      <div class="row" style="font-family: 'FontAwesome' !important;">
        <div class="col-md-12" v-if="lineChartRender">
          <chart-card :chart-data="lineChart.data" :chart-options="lineChart.options" ref="lineChart"
            :responsive-options="lineChart.responsiveOptions">
            <template slot="header">
              <h4 class="card-title">Haftalık Ciro Performansı</h4>
              <p class="card-category">1 Haftalık Performans</p>
            </template>
          </chart-card>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import ChartCard from 'src/components/Cards/ChartCard.vue'
import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table.vue'
import CollectionService from "../services/collection.service.js";
import moment from 'moment';
import numeral from 'numeral';

export default {
  components: {
    LTable,
    ChartCard,
    StatsCard
  },
  mounted() {
    this.getDealers();
    this.getGroups();
    this.generateWeeks();
    setTimeout(() => {
      this.getCardStats();
      this.getWeeklyStats();
    }, 1000);
  },
  data() {
    return {
      pieChartRender: false,
      lineChartRender: false,
      cardStats: {
      },
      weekBySummary: {
        totalConversion: 0,
        totalDeposit: 0,
        totalConversionRefundedAmount: 0
      },
      templates: {},
      pieChart: {
        data: {
          labels: ['90%', '10%'],
          series: [90, 10]
        }
      },
      lineChart: {
        data: {
          labels: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'],
          series: [
            [1000, 250, 0, 0, 0, 0, 0],
            [0, 0, 0, 600, 600, 700, 0],
            [0, 0, 0, 0, 0, 0, 1200]
          ]
        },
        options: {
          low: 0,
          high: 4000,
          showArea: false,
          height: '245px',
          axisX: {
            showGrid: false
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          chartPadding: {
            right: 50
          }
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            axisX: {
              labelInterpolationFnc(value) {
                return value[0]
              }
            }
          }]
        ]
      },
      selectedDealer: 'all',
      selectedGroup: 'all',
      dealers: [],
      groups: [],
      numeral: numeral,
      weeks: [],
      selectedWeek: null,
      weeklyStatsLoading: true
    }
  },
  methods: {
    getDealers() {
      let q = {};
      let p = {};
      let o = { skip: 0, limit: 1000, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('dealer', query).then((res) => {
        if (res.success) {
          this.dealers = res.dealers;
        } else {
          console.log('Bayii listesi yüklenemedi');
        }
      });
    },
    getGroups() {
      let q = {};
      let p = {};
      let o = { skip: 0, limit: 1000, sort: { title: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('affiliate-group', query).then((res) => {
        if (res.success) {
          this.groups = res.affiliateGroups;
        } else {
          console.log('Grup listesi yüklenemedi');
        }
      });
    },
    onGroupChange() {
      this.getWeeklyStats();
      this.getCardStats();
    },
    onDealerChange() {
      this.getWeeklyStats();
      this.getCardStats();
    },
    onWeekChange() {
      this.getWeeklyStats();
      this.getCardStats();
    },
    getCardStats() {
      const params = new URLSearchParams();
      params.append('dealerId', this.selectedDealer);
      params.append('week', this.selectedWeek);
      params.append('group', this.selectedGroup);

      this.cardStats = {
        "totalCustomers": 0,
        "totalActiveCustomers": 0,
        "newCustomers": 0,
        "newCustomersConversion": 0,
        "totalDealers": 0
      }


      CollectionService.getCollection('overview/cards', params).then((res) => {
        if (res.success == true) {
          this.cardStats = res.data;
        } else {
          console.log('error');
        }
      })
    },
    initLineChart() {
      var labels = this.getWeekNamesForLabel(8);
      console.log(labels);
      const series = [100, 200, 300, 400, 500, 600, 700, 800]
      let chartData = {
        labels: labels.map(x => x.text),
        series: [series]
      }
      this.lineChart.data = chartData;
      this.lineChart.options.high = Math.max(...series);
      this.lineChartRender = true;
    },
    getWeekNamesForLabel(range) {
      let currentTimeStamp = new Date().getTime();
      let arr = [];

      for (let i = 0; i < range; i += 1) {
        let endDate = new Date(currentTimeStamp);
        let startDate = new Date(currentTimeStamp - (6 * 1000 * 60 * 60 * 24));

        let formattedStartDate = `${String(startDate.getDate()).padStart(2, '0')}/${String(startDate.getMonth() + 1).padStart(2, '0')}`;
        let formattedEndDate = `${String(endDate.getDate()).padStart(2, '0')}/${String(endDate.getMonth() + 1).padStart(2, '0')}`;

        arr.push({ text: formattedStartDate + ' - ' + formattedEndDate });

        currentTimeStamp -= 7 * 1000 * 60 * 60 * 24;
      }

      return arr.reverse();
    },
    generateWeeks() {
      const weeks = [];
      let currentDate = new Date();

      // Find the most recent Tuesday
      while (currentDate.getDay() !== 2) { // 2 represents Tuesday
        currentDate.setDate(currentDate.getDate() - 1);
      }

      // Generate 12 weeks
      for (let i = 0; i < 36; i++) {
        const endDate = new Date(currentDate);
        const startDate = new Date(currentDate);
        startDate.setDate(startDate.getDate() - 7); // Go back 6 days for the previous Tuesday

        const formattedStartDate = startDate.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        const formattedEndDate = endDate.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });

        weeks.push({
          id: i,
          title: `${formattedStartDate} - ${formattedEndDate}`,
          startDate: startDate,
          endDate: endDate,
          value: moment(startDate).format('DDMMYYYY')
        });

        // Move to the previous week
        currentDate.setDate(currentDate.getDate() - 7);
      }

      this.weeks = weeks;
      this.selectedWeek = this.weeks[0].value; // Select the most recent week by default
    },
    getWeeklyStats() {
      const params = new URLSearchParams();
      params.append('dealerId', this.selectedDealer);
      params.append('week', this.selectedWeek);
      params.append('group', this.selectedGroup);
      this.weeklyStatsLoading = true;

      CollectionService.getCollection('overview/weeklySummary', params.toString()).then((res) => {
        if (res.success == true) {
          this.weekBySummary = res.weekBySummaryData;
        } else {
          console.log('error');
        }
      }).finally(() => {
        this.weeklyStatsLoading = false;
      })
    }
  }
}
</script>
<style></style>